$ = jQuery;
$(document).ready(main);
$(document).on('shopify:section:load', main);
function main() {
    // ==== Header Fix ====
    var topBlock = $('.top-block');
    var sliderBlock = $('.slider-block');

    if (topBlock.length === 0 && sliderBlock.length === 0) {
        $('header').addClass('no-top-block');
    }
    //==== End Header Fix ====
    // ==== Product Fix ====
    var productQuantity = $('.product-form__quantity');
    var buyWrapper = $('.buy-button-wrapper');
    if (productQuantity.length && buyWrapper.length) {
        productQuantity
            .add(buyWrapper)
            .wrapAll('<div class="qb-wrapper"></div>');
    }
    // ==== End Product Fix ====
    //====Burger, Mobile Menu====
    $('.menu-burger').on('click', function () {
        $(this).toggleClass('open');
        $('.mobile-main-menu').toggleClass('open');
    });
    $('.close-menu').on('click', function () {
        $('.menu-burger').toggleClass('open');
        $(this).parent().toggleClass('open');
    });

    var subMenuIcon =
        '<svg class="arrow" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>';
    $(subMenuIcon).insertAfter(
        $('.mobile-main-menu .menu-item-has-children > a')
    );
    $('.mobile-main-menu .menu-item-has-children .arrow').on(
        'click',
        function () {
            $(this).next().slideToggle();
            $(this).toggleClass('active');
            return false;
        }
    );
    //====End Burger, Mobile Menu====

    //====Search====
    var searchBtn = $('.search-box .search-btn');
    if (searchBtn.length > 0) {
        searchBtn.on('click', function () {
            $(this).parent().find('input').val('');
            $(this).toggleClass('close');
            $(this).parent().find('.search-form').toggleClass('active');
        });
    }
    //====End Search====

    // ==== Slider ====
    var sliderBlock = $('.slider-block');
    if (sliderBlock.length) {
        sliderBlock.each(function () {
            var sliderBlockSwiper = new Swiper($(this).find('.swiper').get(0), {
                speed: 3000,
                loop: true,
                spaceBetween: 0,
                navigation: {
                    nextEl: $(this).find('.swiper-button-next').get(0),
                    prevEl: $(this).find('.swiper-button-prev').get(0),
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
            });
        });
    }
    // ==== End Slider ====

    // ==== Product Taber ====
    var taber = $('.product-taber');
    if (taber.length) {
        var navItem = taber.find('.nav-item');
        navItem.on('click', function () {
            navItem.removeClass('active');
            $(this).addClass('active');
            var index = $(this).index();
            $('.product-taber .info').hide().eq($(this).index()).fadeIn(500);
        });
        navItem.first().click();
    }
    // ==== End Product Taber ====

    // ==== Product Slider ====
    var productSlider = $('.product-gallery');
    if (productSlider.length) {
        var thumbsSwiper = new Swiper(
            productSlider.find('.thumbs-slider').get(0),
            {
                spaceBetween: 10,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                    },
                },
            }
        );

        var mainSwiper = new Swiper(productSlider.find('.main-slider').get(0), {
            spaceBetween: 10,
            loop: true,
            pagination: {
                el: productSlider.find('.swiper-pagination').get(0),
                clickable: true,
            },
            thumbs: {
                swiper: thumbsSwiper,
            },
        });

        var activeVariant = $('input.product-variant-id');
        if (activeVariant.length) {
            var index = $(
                '[data-variant-ids="' + activeVariant.val() + '"]'
            ).index();
            mainSwiper.slideTo(index);

            activeVariant.on('change', function (event) {
                var id = $(this).val();
                var index = $('[data-variant-ids="' + id + '"]').index();
                mainSwiper.slideTo(index);

                var variationType = $('input[name^="Size-1"]:checked');
                if (variationType.length) {
                    if (variationType.val() === 'Slab') {
                        $('.product-buil-box-btn').hide();
                    } else {
                        $('.product-buil-box-btn').show();
                    }
                }
            });
        }

        var variationType = $('input[name^="Size-1"]:checked');
        if (variationType.length) {
            if (variationType.val() === 'Slab') {
                $('.product-buil-box-btn').hide();
            }
        }
    }
    // ==== End Product Slider ====

    // ==== Taber Block ====
    $('.taber-block .infos').each(function () {
        const $container = $(this);
        const $children = $container.children();

        let currentInfo = null;
        let currentTitle = '';

        $children.each(function () {
            const $el = $(this);

            if ($el.hasClass('nav-item')) {
                if (currentInfo) $container.append(currentInfo);

                currentTitle = $el.text().trim();
                currentInfo = $(
                    '<div class="info" style="display: none;">'
                ).attr('data-title', currentTitle);
                $el.remove();
            } else if ($el.hasClass('card')) {
                if (currentInfo) {
                    currentInfo.append($el);
                }
            }
        });

        if (currentInfo) $container.append(currentInfo);
    });
    var taberBlock = $('.taber-block');
    if (taberBlock.length) {
        var navItem = taberBlock.find('.nav-item');
        navItem.on('click', function () {
            navItem.removeClass('active');
            $(this).addClass('active');
            var index = $(this).index();
            $('.taber-block .info').hide().eq($(this).index()).fadeIn(500);
        });
        navItem.first().click();
    }
    // ==== End Taber Block ====

    // ==== Build Box ====
    /*Box Size Functionality*/
    var sizeBtns = $('.size-btns-wrapper');
    if (sizeBtns.length) {
        var sizeBtn = sizeBtns.find('.size-item');
        sizeBtn.on('click', function () {
            var bodyWrapper = $('.body-wrapper');
            var placeholderSVG = $('.placeholder-svg');
            var value = +$(this).html();
            var inner = '';
            var svg;

            if (placeholderSVG.length) {
                svg = placeholderSVG.find('svg').prop('outerHTML');
            } else {
                svg =
                    '<svg width="91" height="73" viewBox="0 0 91 73" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M38.9548 0.0730503C43.6844 -0.740452 50.818 5.56494 55.8379 5.62304C57.0777 5.63794 58.2656 5.33847 59.4684 5.80928C60.9081 6.37099 61.4517 7.90711 62.73 8.293C63.5166 8.5299 64.3742 8.46434 65.1785 8.61929C66.8923 8.95006 68.4817 9.54156 70.2488 9.70098C72.2544 9.88126 74.2851 9.63394 76.2833 9.91404C78.4193 10.2135 89.41 14.2453 90.0469 16.4444C90.3372 17.4456 90.8186 20.0307 90.8201 20.9157C90.826 24.1295 89.176 27.163 89.6929 30.4289C90.1002 33.005 89.5477 40.7586 88.4931 42.5599C87.828 43.6952 86.3246 43.8428 85.2981 44.5088C83.4925 45.6813 81.7461 46.9597 79.9523 48.1531C75.4346 51.1553 71.853 53.3232 68.0729 57.5531C63.7225 62.4192 58.2419 70.5319 51.7971 72.1857C49.0983 72.5433 44.2369 68.957 41.8106 67.6355C34.0327 63.3936 25.4119 61.0902 17.1096 58.1476C14.7234 57.3013 4.56804 53.4245 2.77575 52.0448C-0.490363 49.5298 0.703509 43.5999 1.05308 40.027C1.32414 37.2647 1.20565 34.3683 0.810158 31.6253C0.333201 28.3117 -0.980651 24.566 1.31229 21.616C5.7234 15.9423 12.1475 16.1703 17.3229 13.1621C20.7268 11.182 22.0229 8.24979 26.1925 6.14899L28.5181 4.95108C30.5251 3.90813 36.9507 0.323359 38.9563 0.0745402L38.9548 0.0730503ZM39.885 1.76412C38.2957 3.58482 35.9405 6.1475 33.3335 6.37248C31.9234 6.49465 33.9127 4.76782 34.1082 4.5339C34.5052 4.06309 34.8518 3.55055 35.268 3.0991C33.3676 3.96624 31.5738 5.0524 29.7327 6.03575C26.4043 7.81324 24.7572 8.38537 22.1088 11.0926C18.459 14.8234 16.2327 15.4178 11.3417 16.9897C8.01783 18.058 3.88519 19.7774 1.90479 22.8675C2.81871 23.7048 3.74003 24.7463 4.78726 25.3959C7.04318 26.7979 10.1375 25.5613 12.7118 26.7518C14.9411 27.7828 16.8326 30.7463 19.3729 30.9161C21.8407 31.0815 21.66 29.3547 25.6 31.4674C28.5743 29.742 32.8358 28.2387 36.2723 29.1759C36.4234 29.2161 40.6093 31.0919 40.6701 31.1992C41.3648 32.4343 37.5313 31.1932 37.401 31.1754C35.0695 30.8595 30.5488 31.1694 29.072 33.4207C30.263 34.0643 31.6583 34.118 32.8714 34.708C36.3019 36.3737 34.3393 38.6995 39.4036 36.7239C45.9299 34.1776 48.3903 45.3059 54.7684 39.811C55.4246 39.2761 55.9875 38.631 56.6007 38.0484C58.7529 36.0042 61.2222 34.6111 63.9817 33.5965C67.4685 32.3152 68.4491 31.9382 71.059 29.2831C73.4867 26.8128 75.9071 24.3843 79.265 23.2757C79.6827 23.1387 80.9685 23.012 80.1182 22.4548C78.4104 21.3373 74.3666 20.351 72.3773 20.798C70.2117 21.2837 65.4955 25.3363 64.2024 24.4617C63.6306 24.0758 65.3059 23.7689 65.4511 23.7168C69.7674 22.1345 69.8074 18.727 76.467 20.3153C77.4639 20.5536 81.0425 21.5713 81.5728 22.3728C82.2616 22.0466 84.6849 19.5315 85.5455 18.806C86.0032 18.4201 88.4531 16.9048 88.5524 16.726C88.3716 15.169 83.8139 14.9947 82.4289 15.8216C81.3076 16.4906 80.4382 17.8807 78.9762 17.7511C76.3663 17.5187 77.9541 14.1276 79.7983 12.9312C79.9894 12.8075 80.296 12.6838 80.4397 12.517C75.5768 10.4162 73.7534 11.4219 69.1734 10.8497C67.7662 10.6739 66.4924 10.0571 65.1104 9.84849C64.2083 9.71141 63.2426 9.87531 62.3597 9.65182C60.8904 9.27784 60.1809 7.71789 58.8078 7.21578C57.8005 6.84777 56.7903 7.15171 55.7623 7.17555C50.7187 7.29326 44.1139 1.28436 39.885 1.76412ZM1.55077 24.8297C1.3908 27.382 1.97144 29.6094 2.34768 32.0946C2.91795 35.8508 2.51654 39.5681 2.22029 43.3287C2.03514 45.6903 1.61743 48.8102 3.51192 50.6339C4.49546 51.5814 15.227 55.8427 16.8504 56.4282C25.5823 59.5764 34.7822 61.9469 42.926 66.5165C43.8918 67.0574 51.9274 72.6223 52.0667 69.8108C52.1289 68.5577 51.9215 67.6518 52.1185 66.2856C52.6325 62.7276 54.6707 57.0361 53.7271 53.8447C52.8591 53.0356 51.7304 52.5037 50.6876 51.9614C43.6162 48.2827 39.1311 47.946 39.1874 38.6265C34.5304 40.0702 35.3332 38.0112 32.4537 36.2188C31.2346 35.4589 29.5046 35.3844 28.1433 34.7661C26.4828 34.0137 25.0757 32.5357 23.3634 32.0127C20.7742 31.2245 20.8157 33.6501 16.1216 31.2677C14.5219 36.3678 17.5066 39.075 20.8201 42.3036C23.1693 44.5922 24.2891 46.836 25.3616 49.9097C26.3066 52.3279 27.2072 54.1605 23.4715 52.0403C20.3046 50.242 17.9495 47.207 14.6137 45.6977C13.9842 45.4131 13.134 45.2373 12.6096 44.7799C12.5785 43.7414 16.2372 45.7588 16.7378 46.0583C19.1804 47.5124 21.2482 49.6103 23.7337 50.9661C22.3236 49.0426 20.8379 46.8554 18.9019 45.437C15.2936 42.7938 10.5744 43.5284 10.527 36.8043C10.5063 33.8036 11.3091 33.6278 11.3269 36.8296C11.3565 42.1919 14.8137 42.104 18.2887 44.0349C20.9712 45.5249 22.522 48.2157 24.5854 50.3761C23.9929 48.3379 23.2404 46.5187 21.9503 44.8216C19.2278 41.2413 12.2616 36.7522 15.6817 30.8848L15.6165 30.8386C14.7752 30.2367 14.1012 29.4232 13.2747 28.8064C11.1166 27.1943 9.48721 28.1284 7.12316 27.8334C4.53545 30.3723 7.42682 32.2719 7.53495 35.006C7.58679 36.3007 7.0017 37.4912 6.85506 38.7591C6.8358 38.923 7.0491 41.5855 5.9841 40.1835C5.37679 39.3849 5.78709 38.0603 5.82561 37.15C5.95151 34.2327 2.40544 31.7341 2.42322 27.0304C2.75798 28.1374 3.0246 29.2846 3.5608 30.3157C4.52064 32.1617 5.81376 33.6472 6.52771 35.6437C6.9069 32.6221 3.63635 30.5973 6.20628 27.5995C3.2453 26.8143 3.3638 25.8518 1.55077 24.8297ZM88.5524 18.651C85.5736 19.3647 84.8345 21.7396 82.6645 23.3175C81.3832 24.2502 79.508 24.6107 78.0415 25.381C75.4612 26.7339 71.8515 30.4647 69.6474 32.7711C69.5215 33.4862 69.4919 34.2103 69.3897 34.927C68.4624 41.3993 64.8541 47.3798 59.7705 51.4325C65.3977 48.8832 70.5421 41.4395 72.638 35.8791C72.7521 35.5766 73.1653 33.7812 73.1787 33.7678C73.7815 34.6558 72.3877 38.1259 72.0322 38.9886C69.7911 44.4238 66.8834 46.6528 62.9419 50.3761C60.3586 52.17 57.7768 53.6986 54.6174 54.1605C55.2898 57.6753 53.622 61.6951 53.0502 65.18C52.7614 66.9352 52.8458 68.2806 52.7836 70.0223L52.828 70.0059C59.8165 67.3807 64.7416 57.8123 70.3243 53.0878C72.6054 51.1568 74.9754 49.4881 77.4935 47.8909C78.6844 47.1355 81.0677 46.0851 81.6543 44.7784C82.2616 43.4241 82.2364 41.8746 82.7667 40.5098C83.1133 39.6158 83.965 39.0347 84.2701 38.1408C84.5427 37.3437 84.0938 35.7256 85.0774 35.3546C86.9393 34.6529 86.1394 34.5635 87.4533 33.5265C87.7969 33.2553 88.2191 33.1987 88.5553 32.9677C88.7849 32.3897 88.0724 29.7063 88.0547 28.7796C88.0176 26.795 90.4854 18.4722 88.5553 18.651H88.5524ZM69.4519 32.7711C67.7736 34.036 65.6703 34.5158 63.7521 35.2905C60.877 36.4527 53.6782 41.0953 53.1954 44.4909C52.9021 46.5529 54.05 49.6431 54.6159 51.6843C54.7699 52.0701 54.9151 52.4531 55.0454 52.8479C59.6787 51.7513 63.2011 47.3083 65.5814 43.4464C67.7959 39.8542 68.3202 36.6345 69.4993 32.8307L69.4519 32.7711ZM41.6803 37.8428C40.9411 37.9098 40.2109 38.0708 39.531 38.3777C39.9798 46.9537 44.0814 47.7732 50.7854 50.9661C47.9429 48.6031 43.9051 44.4849 42.8519 40.7571C43.4415 41.2503 43.8118 41.9148 44.1628 42.5882L44.2161 42.6493C44.662 43.1633 45.0323 43.7563 45.4308 44.3091C48.291 48.2887 50.3529 48.9979 53.7301 51.6843C52.9036 48.3781 51.7941 46.1998 52.7821 42.8147C47.6659 43.9232 44.9138 37.6834 41.6803 37.8428ZM88.2383 34.0524C87.0519 34.8898 86.766 36.1353 85.1544 36.2337C85.5884 37.8651 84.5086 39.072 83.7843 40.2267C83.5443 40.6096 82.6422 43.798 82.6808 44.3195C83.6613 43.9709 84.4671 43.0739 85.421 42.6136C85.895 42.3841 86.843 42.2411 87.1733 41.8418C87.7436 41.2994 88.0384 36.6225 88.1406 35.66C88.1746 35.3427 88.5094 34.255 88.2413 34.0539L88.2383 34.0524ZM81.2528 13.101C80.0575 13.5867 79.1732 14.0859 78.6459 15.3538C77.6446 17.7645 80.3345 16.796 80.6589 16.136C81.9461 15.6011 81.9594 14.509 84.3916 14.4166C84.0627 13.9994 81.8779 13.0623 81.2528 13.0995V13.101ZM33.2476 29.7286C31.3561 30.0177 27.9996 30.937 26.4947 32.0619C27.0857 32.4343 27.6752 32.8158 28.2914 33.1465C28.4381 32.8292 28.5906 32.5699 28.835 32.3166C30.7903 30.5094 33.9512 30.2739 36.4945 30.2144C35.3747 29.8136 34.4297 29.6959 33.2476 29.7301V29.7286ZM38.4438 1.76412C37.047 2.02188 36.81 2.26921 35.9879 3.42986C35.9064 3.54459 34.5793 5.0077 35.2695 4.80507C36.1449 4.3417 38.3431 2.86667 38.6689 1.92652C38.7341 1.7373 38.586 1.75667 38.4438 1.76412Z" fill="#D4AFB6"></path><path d="M57.0513 41.8403C57.4601 41.8433 57.349 42.2843 57.3431 42.5882C57.9681 42.5539 58.534 42.7551 57.8215 43.3287C56.8602 43.5745 56.2188 42.5003 57.0527 41.8403H57.0513Z" fill="#D4AFB6"></path><path d="M86.1455 24.8297C86.7068 24.7254 86.7068 25.4376 86.1455 25.5851C85.5663 25.5419 85.8285 25.0532 86.1455 24.8297Z" fill="#D4AFB6"></path><path d="M58.5144 61.926C59.1025 62.1346 58.904 62.5443 58.5144 62.8006C57.8419 62.8051 57.993 62.1346 58.5144 61.926Z" fill="#D4AFB6"></path><path d="M55.5048 65.1547C56.275 65.4452 55.7225 66.0769 55.2337 66.2662C54.5657 65.8818 54.9138 65.4288 55.5048 65.1547Z" fill="#D4AFB6"></path><path d="M63.9522 54.457C64.6988 54.6879 64.5107 55.2034 63.9522 55.5014C63.1361 55.4254 63.3405 54.7326 63.9522 54.457Z" fill="#D4AFB6"></path><path d="M86.3527 22.5576C87.2133 22.4518 86.9659 23.3249 86.3527 23.5364C85.6047 23.7257 85.8446 22.7945 86.3527 22.5576Z" fill="#D4AFB6"></path><path d="M77.2935 40.544C78.6385 40.5038 78.5422 42.1859 77.6312 42.8131C76.3233 42.8757 76.3322 41.1027 77.2935 40.544Z" fill="#D4AFB6"></path><path d="M68.1352 50.0945C69.3957 50.1139 69.0313 52.3949 68.1352 52.8479C66.6421 52.6631 67.439 50.7232 68.1352 50.0945Z" fill="#D4AFB6"></path><path d="M79.7183 28.5531C82.6911 28.4458 83.7561 34.6543 81.0617 35.6422C80.8692 35.669 80.6366 35.6422 80.4411 35.6422C80.2426 35.6049 79.9953 35.5811 79.8146 35.4917C78.6755 34.9315 77.0743 29.4172 79.7198 28.5531H79.7183ZM79.7183 29.4277C78.4222 30.3529 79.4605 34.7571 80.4826 34.9181C80.6618 34.9464 80.9803 34.8644 81.0617 34.6767C82.5134 33.811 81.6735 29.1535 79.7183 29.4277Z" fill="#D4AFB6"></path><path d="M36.2813 45.6575C36.8752 45.7484 37.053 46.7839 36.4961 47.1742C35.7599 46.8628 35.7495 46.173 36.2813 45.6575Z" fill="#D4AFB6"></path><path d="M50.9869 57.3385C51.649 57.3623 52.326 57.9896 51.7957 58.6467C51.0906 58.7003 50.6655 57.93 50.9869 57.3385Z" fill="#D4AFB6"></path><path d="M50.1679 58.9849C50.8923 59.0132 51.3811 59.6881 50.9871 60.3332L50.9574 60.3288C50.3131 60.2334 49.6569 59.5823 50.1679 58.9849Z" fill="#D4AFB6"></path><path d="M42.5218 49.9112C43.1113 49.8248 43.9334 50.3135 43.569 50.9661C42.9009 51.0838 42.1648 50.6219 42.5218 49.9112Z" fill="#D4AFB6"></path><path d="M27.0443 53.8447C27.8427 53.9296 27.1391 54.9904 26.4948 55.1111C25.4861 54.5852 26.3304 54.086 27.0443 53.8447Z" fill="#D4AFB6"></path><path d="M26.5867 36.5555C27.1303 36.6091 26.9362 37.0412 27.111 37.4032C27.4043 38.0082 28.2101 37.6074 27.4206 38.625C26.6252 38.4194 25.8609 37.2185 26.5867 36.5555Z" fill="#D4AFB6"></path><path d="M11.7905 51.4324C12.854 51.3192 12.8732 52.5022 12.3963 53.201C11.3831 53.5124 11.509 51.9733 11.7905 51.4324Z" fill="#D4AFB6"></path><path d="M43.569 62.6039C44.4014 62.5965 43.9052 63.2297 43.569 63.5575C43.9215 63.9538 44.3229 64.2041 43.9126 64.6958C42.8032 64.8135 42.5084 63.1835 43.569 62.6039Z" fill="#D4AFB6"></path><path d="M5.48493 46.8688C6.80767 46.7302 6.58104 48.2946 5.77081 48.8921C4.56509 49.2288 4.85097 47.4603 5.48493 46.8688Z" fill="#D4AFB6"></path><path d="M38.7283 56.8855C39.7681 56.8438 39.5119 58.8105 38.7283 59.2143C37.5345 58.7927 37.9551 57.4845 38.7283 56.8855Z" fill="#D4AFB6"></path><path d="M30.1666 45.3535C32.3396 45.0734 34.2045 48.4004 32.31 49.9097C30.5103 50.6889 28.5787 46.8166 30.1666 45.3535ZM30.4851 46.1119C30.1622 47.0624 30.7547 49.5 32.1337 49.0664C32.6729 47.7031 31.8019 46.5335 30.4851 46.1119Z" fill="#D4AFB6"></path><path d="M62.9405 28.3266C63.4723 28.6052 63.4426 29.1669 62.9405 29.4277C62.3762 29.152 62.5302 28.6603 62.9405 28.3266Z" fill="#D4AFB6"></path><path d="M26.5866 23.7748C27.2532 23.7242 27.422 24.3127 27.0443 24.8282C26.4163 24.8312 26.1571 24.2039 26.5866 23.7748Z" fill="#D4AFB6"></path><path d="M52.3705 21.3135C52.8311 21.248 53.9035 21.391 53.3969 22.0451C52.9659 22.1136 51.8194 21.9482 52.3705 21.3135Z" fill="#D4AFB6"></path><path d="M28.8352 23.9208C29.795 24.0579 28.9611 24.8535 28.5996 25.1232C27.7628 25.0934 28.416 24.1846 28.8352 23.9208Z" fill="#D4AFB6"></path><path d="M65.0304 29.1967C65.851 29.1684 65.5177 29.9432 64.749 30.2129C63.801 30.3648 64.5268 29.4217 65.0304 29.1967Z" fill="#D4AFB6"></path><path d="M61.8548 18.87C62.7954 19.0264 61.997 20.0366 61.5023 20.269C60.4417 19.8176 61.1261 19.1099 61.8548 18.87Z" fill="#D4AFB6"></path><path d="M37.8603 13.7401C38.3536 13.8072 38.1655 14.0366 38.4291 14.3376C39.0676 14.2288 39.7697 14.1856 39.189 15.0617C38.2484 15.1973 36.8916 14.6073 37.8589 13.7386L37.8603 13.7401Z" fill="#D4AFB6"></path><path d="M52.7823 30.2128C53.2577 30.487 53.1274 30.7865 53.0104 31.2677C53.5747 31.2826 54.4738 31.4525 53.7303 32.0618C52.4505 32.2928 52.0105 31.2051 52.7823 30.2128Z" fill="#D4AFB6"></path><path d="M72.8232 14.2273C73.2039 13.9874 74.0852 14.567 73.7609 15.0557C73.4646 15.5027 72.7981 14.7697 72.8232 15.5236C72.2589 16.9435 70.9495 14.9052 72.8232 14.2273Z" fill="#D4AFB6"></path><path d="M31.3119 10.5413C31.8332 10.6113 32.7027 11.03 32.4272 11.6766C31.7266 12.064 30.7949 10.4548 30.4853 12.3247C30.4616 14.9976 28.2176 11.0896 31.3119 10.5413Z" fill="#D4AFB6"></path><path d="M33.2476 20.269C35.2947 20.1677 35.8249 21.8454 33.926 22.866C31.7516 23.3279 31.1754 20.8888 33.2476 20.269ZM33.2476 21.3135C32.31 21.6264 32.9899 22.2164 33.7023 22.045C34.6844 21.5161 34.046 21.1257 33.2476 21.3135Z" fill="#D4AFB6"></path><path d="M41.4035 20.8889C43.1558 20.9008 43.5779 24.8476 41.679 24.6465C40.1281 23.9268 39.0231 21.5698 41.4035 20.8889ZM41.4035 21.7307C40.2762 22.2074 41.1146 23.1223 41.679 23.7749L41.8552 23.7957C42.2937 23.4322 42.1085 21.7247 41.4035 21.7307Z" fill="#D4AFB6"></path><path d="M42.5217 8.44942C43.4445 8.39728 44.477 8.52541 45.0369 9.35381C45.1094 10.5264 44.7051 10.9749 43.5675 11.3265C40.5117 11.1343 39.937 8.93663 42.5203 8.44942H42.5217ZM42.5217 9.35381C40.6213 9.87827 42.7513 10.5413 43.569 10.5398C45.3924 9.65925 43.4505 9.28378 42.5217 9.35381Z" fill="#D4AFB6"></path><path d="M58.5146 11.328C60.4995 11.0985 62.8828 13.9413 60.6698 15.3508C59.4478 15.1914 55.9802 12.1862 58.5146 11.328ZM58.5146 12.3247C58.0628 12.9714 60.1143 14.351 60.6698 14.4181C61.2312 13.4183 59.6448 12.1772 58.5146 12.3247Z" fill="#D4AFB6"></path><path d="M55.7356 24.8297C56.7739 24.7389 59.6949 24.8089 60.2948 25.7803C60.9643 26.865 58.861 25.9308 58.5988 25.8533C56.257 25.159 53.0827 26.0872 50.9868 27.2211C50.2595 27.6532 48.1502 29.7957 47.9028 29.3174C47.9458 26.9797 53.8174 25.0949 55.7371 24.8312L55.7356 24.8297Z" fill="#D4AFB6"></path><path d="M48.7607 15.3508C51.4625 14.7116 54.0206 18.7687 50.987 18.8715C49.8939 18.7613 46.1804 17.6319 47.5432 15.8812C47.8468 15.4909 48.306 15.4134 48.7607 15.3523V15.3508ZM48.7607 16.136C46.8322 17.0687 50.2257 18.1042 50.987 18.2293C52.8667 17.6676 49.7591 16.0838 48.7607 16.136Z" fill="#D4AFB6"></path><path d="M23.0126 14.2274C26.2209 13.8981 28.2769 17.3935 24.8567 18.2293C21.6187 18.3664 19.2251 14.6088 23.0126 14.2274ZM22.8111 15.0632C20.3864 15.8261 23.6836 17.5991 25.0567 17.3398C27.2993 16.2418 24.5442 14.953 22.8111 15.0632Z" fill="#D4AFB6"></path><path d="M13.3163 19.1561C14.3206 19.0399 16.7084 19.5911 16.1173 21.0274C15.6745 22.1047 13.8866 22.8124 12.8779 23.2176C8.42235 24.1935 9.01336 19.6209 13.3178 19.1561H13.3163ZM13.1178 20.053C10.4546 20.4911 9.18666 23.4486 12.8764 22.3714C13.9459 22.0019 14.8346 21.5102 15.5145 20.5805C14.7739 20.138 13.9799 19.9666 13.1178 20.053Z" fill="#D4AFB6"></path></g></svg>';
            }

            sizeBtn.removeClass('active');
            $(this).addClass('active');
            bodyWrapper.empty();

            for (let i = 1; i <= value; i++) {
                inner += `<div class="box-item" data-box-id="${i}">${svg}</div>`;
            }
            $('.box-max-size-value').html(value);

            bodyWrapper.attr('data-box-grid', value);
            bodyWrapper.append(inner);
            $('.current-in-box').html(0);
            $('.total-price-box').html('0.00');
            $('.add-box-to-cart').addClass('not-filled-box');
            $('.box-quantity .quantity').attr('max', value);
        });
    }

    /*Reset Link Functionality*/
    $('.clear-box-link').on('click', function () {
        $('.size-item.active').click();
        $('.error-message').hide();
        $('.add-box-to-cart').addClass('not-filled-box');
        $('.box-quantity .quantity').val(1);
        return false;
    });

    /*Variation Taber Functionality*/
    var variantionItem = $('.box-nav-items').find('.nav-item');
    if (variantionItem.length) {
        variantionItem.on('click', function () {
            variantionItem.removeClass('active');
            $(this).addClass('active');
            var id = $(this).data('box-nav');

            $('.size-btns-wrapper').hide();
            $('.size-btns-wrapper[data-box-size=' + id + ']').fadeIn(500);

            $('.tab-wrapper').hide();
            $('.tab-wrapper[data-box-info=' + id + ']').fadeIn(500);

            $('[data-box-size="' + id + '"]')
                .find('.size-item')
                .first()
                .click();
        });

        var hash = window.location.hash.replace('#', '');
        if (hash) {
            $('[data-box-nav="' + hash + '"]').click();
            $('.box-nav-items').hide();
        } else {
            variantionItem.first().click();
        }
    }

    function totalPrice() {
        var boxQuantity = +$('.box-quantity .quantity').val();
        var productInBox = $('.box-item.filled');
        var totalPrice = $('.total-price-box');
        var newTotalPrice = 0;

        productInBox.each(function () {
            var price = +$(this).data('price');
            newTotalPrice += price;
        });

        totalPrice.text(newTotalPrice * boxQuantity);
    }

    /*Quantity Input Functionality*/
    var boxQuantity = $('.box-quantity');
    if (boxQuantity.length) {
        boxQuantity.find('.plus').on('click', function () {
            var qInput = boxQuantity.find('.quantity');
            var currentValue = +qInput.val();
            var maxValue = +qInput.attr('max');
            var newValue;
            if (currentValue >= maxValue) {
                newValue = maxValue;
            } else {
                newValue = currentValue + 1;
            }
            qInput.val(newValue);

            totalPrice();
        });
        boxQuantity.find('.minus').on('click', function () {
            var qInput = boxQuantity.find('.quantity');
            var currentValue = +qInput.val();
            var newValue;

            if (currentValue === 1) {
                newValue = currentValue;
            } else {
                newValue = currentValue - 1;
            }
            qInput.val(newValue);

            totalPrice();
        });
    }

    /*Add To Box Btn Functionality*/
    var addToBox = $('.add-to-box');
    if (addToBox.length) {
        addToBox.on('click', function () {
            var img = $(this).parents('.product-item').find('img').clone();
            var productId = $(this).parents('.product-item').data('product-id');
            var price = $(this)
                .parents('.product-item')
                .find('.price')
                .html()
                .replace('$', '');
            var priceValue = +price;
            var box = $('.body-wrapper .box-item').not('.filled').first();
            var countInBox = $('.current-in-box');
            var countInBoxValue = +countInBox.html();
            var maxInBox = $('.box-max-size-value').text();
            var maxInBoxValue = +maxInBox;
            var removeBtn = '<span class="remove-item-from-box"></span>';
            if (box.length) {
                box.attr('data-box-product', productId);
                box.attr('data-price', priceValue);
                box.append(img);
                box.append(removeBtn);
                box.addClass('filled');
                var newCount = ++countInBoxValue;
                countInBox.text(newCount);
                if (newCount === maxInBoxValue) {
                    $('.add-box-to-cart').removeClass('not-filled-box');
                }
            }
            totalPrice();
            return false;
        });
    }
    $(this).on('click', '.remove-item-from-box', function () {
        var parent = $(this).parent();
        parent.removeClass('filled');
        parent.attr('data-box-product', '');
        parent.find('img').remove();
        $(this).remove();
        $('.add-box-to-cart').addClass('not-filled-box');
        var currentInBox = $('.current-in-box');
        currentInBox.text(currentInBox.text() - 1);
        totalPrice();
    });
    /*Add Box To Cart Btn Functionality */
    var addBoxCart = $('.add-box-to-cart');
    if (addBoxCart.length) {
        addBoxCart.on('click', function () {
            var $this = $(this);
            $this.addClass('loader');
            var productList = [];
            var productListItem = $('.box-item.filled');
            var boxQuantity = +$('.box-quantity .quantity').val();
            var bundleId = new Date().getTime();
            var currentNavItem = $('.box-nav-items .nav-item.active');
            var boxVariation = $('.box-nav-items .nav-item.active').text();
            var boxSize = $('.size-btns-wrapper .size-item.active').text();
            var boxTitle = currentNavItem.attr('data-box-title');
            var bundleTitle = `${boxTitle} Box - ${boxSize} ${boxVariation}`;

            var totalPrice = 0;

            productListItem.each(function () {
                var price = +$(this).data('price');
                totalPrice += price;
            });

            productListItem.each(function () {
                var id = $(this).data('box-product');
                var existing = productList.find((i) => i.id === id);

                if (existing) {
                    existing.quantity += boxQuantity;
                } else {
                    productList.push({
                        id: id,
                        quantity: boxQuantity,
                        properties: {
                            _bundle_id: bundleId,
                            _bundle_title: bundleTitle,
                            _total_price: totalPrice * boxQuantity,
                            Box: `${bundleTitle} (#${bundleId})`,
                        },
                    });
                }
            });
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({
                    items: productList,
                }),
                dataType: 'json',
                contentType: 'application/json',
                success: function (cart) {
                    console.log('Products added:', cart);
                    setTimeout(function () {
                        $this.removeClass('loader');
                        window.location.href = '/cart';
                    }, 500);
                },
                error: function (err) {
                    var errorMessage = err.responseJSON.message;
                    if (errorMessage) {
                        var errorBox = $('.error-message');
                        errorBox.text(errorMessage);
                        errorBox.show();
                        $this.removeClass('loader');
                    }
                    console.error('Error:', err);
                },
            });

            /* Add Product To Cart */
            /* $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({
                    items: productList,
                }),
                dataType: 'json',
                contentType: 'application/json',
                success: function (cart) {
                    console.log('Products added:', cart);
                    setTimeout(function () {
                        $this.removeClass('loader');
                        window.location.href = '/cart';
                    }, 500);
                },
                error: function (err) {
                    var errorMessage = err.responseJSON.message;
                    if (errorMessage) {
                        var errorBox = $('.error-message');
                        errorBox.text(errorMessage);
                        errorBox.show();
                        $this.removeClass('loader');
                    }
                    console.error('Error:', err);
                },
            });*/
            return false;
        });
    }
    /*Popup Taber */
    var productPopupTaber = $('.product-popup-taber');
    if (productPopupTaber.length) {
        productPopupTaber.each(function () {
            var $this = $(this);
            var navItem = $this.find('.nav-item');
            navItem.on('click', function () {
                navItem.removeClass('active');
                $(this).addClass('active');
                var index = $(this).index();
                $this.find('.info').hide();
                $this.find('.info').eq($(this).index()).fadeIn(500);
            });
            navItem.first().click();
        });
    }
    //$(this).parents('.product-popup-taber').find('.info').eq($(this).index()).fadeIn(500);
    // ==== End Build Box ====

    // ==== Beverage Variation ====
    /*var beverageAddCart = $('.beverage-add-to-cart-btn');
    if (beverageAddCart.length) {
        beverageAddCart.each(function () {
            $(this).on('click', async function (e) {
                const productId = e.target.dataset.productId;
                const productURL = e.target.dataset.productUrl;
                const selected = document.querySelector(
                    `input[name="size-${productId}"]:checked`
                );
                const variantValue = selected.value;

                const productResponse = await fetch(`${productURL}.js`);
                const productData = await productResponse.json();
                const matchedVariant = productData.variants.find(
                    (variant) => variant.option1 === variantValue
                );

                const formData = {
                    id: matchedVariant.id,
                    quantity: 1,
                };

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData),
                });

                if (response.ok) {
                    const data = await response.json();
                    setTimeout(function () {
                        window.location.href = '/cart';
                    }, 500);
                } else {
                    console.log('Error adding to cart');
                }
            });
        });
    }*/
    // ==== End Beverage Variation ====
    // ==== Product Build Box Btn ====
    var productBuilBoxBtn = $('.product-buil-box-btn');
    if (productBuilBoxBtn.length) {
        productBuilBoxBtn.on('click', function () {
            var selectedVariation = $(
                '.variation-wrapper input[name^="Size-1"]:checked'
            );
            var selectedVariationValue = selectedVariation
                .val()
                .toLowerCase()
                .trim();
            var link = $(this).attr('href');
            var baseLink = link.split('#')[0];
            var newLink = baseLink + '#' + selectedVariationValue;
            $(this).attr('href', newLink);

            console.log(selectedVariationValue);
        });
    }
    // ==== End Product Build Box Btn ====

    // ==== Delivery ====
    /*var pickupDelivery = $('.standard-delivery .pickup-option');
    var productForm = $('.product-form form.form');
    if (pickupDelivery.length && productForm.length) {
        pickupDelivery.on('click', function () {
            $(this).toggleClass('active');
            var value = '';
            var deliveryInput = productForm.find(
                'input[name="properties[Pickup]"]'
            );
            if ($(this).hasClass('active')) {
                value = pickupDelivery.find('.price-value').text();
            } else {
                value = '';
            }
            if (deliveryInput.length) {
                deliveryInput.val(value);
            } else {
                var input =
                    '<input type="hidden" name="properties[Pickup]" value="' +
                    value +
                    '">';
                productForm.append(input);
            }
        });
    }*/
    // ==== End Delivery ====


    function updateQnt(t){
        var id = t.val();
            var variant = $('[data-qty-id="' + id + '"]');
            var min = parseInt(variant.data('qty-min')) || 0;
            var max = parseInt(variant.data('qty-max')) || min;
            var quantityInput = $('.quantity__input');
    
            if (quantityInput.length && min && max ) {
                // console.log(id + ' ' + min + ' ' + max);
                quantityInput.val(min);
                quantityInput.prop('min', min);
                quantityInput.prop('max', max);
                quantityInput.change();
            }
        }
    

    // ==== Min/Max Quantity ====
    var productFormQty = $('.product-form form.form');
    if (productFormQty.length) {
        var variantInput = productFormQty.find('.product-variant-id');
        if (variantInput.length) {
            variantInput.on('change', function() {

             setTimeout(()=>{
                updateQnt($(this));
             }, 100);

             setTimeout(()=>{
                updateQnt($(this));
             }, 200);

             setTimeout(()=>{
                updateQnt($(this));
             }, 300);
    
                

                
            })
        }
    }
    // ==== End Min/Max Quantity ====

    // ==== Beverage Product ====
    var beverageProduct = $('.beverage-product-tpl');
    if (beverageProduct.length) {
        //$('.variation-wrapper').hide();
        var variationList = $('.variation-wrapper input[name^="Size-1"]');
        var sizeOption = $('.additional-options .size-option .option-list');
        var tpl = '';
        var svg =
            '<svg width="31" height="41" viewBox="0 0 31 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.9978 5.51794V7.84197C30.9978 8.61376 30.3821 9.24486 29.6249 9.24486H1.37289C0.615781 9.24486 0 8.61376 0 7.84197V5.51794C0 4.74615 0.615703 4.11505 1.37289 4.11505H29.6249C30.3821 4.11505 30.9978 4.74615 30.9978 5.51794Z" fill="currentColor"/><path d="M26.7754 3.26214H4.21875L5.4918 1.13855C5.91195 0.434904 6.66914 0 7.47203 0H23.5221C24.325 0 25.0863 0.434984 25.5065 1.13855L26.7754 3.26214Z" fill="currentColor"/><path d="M28.7675 10.0977C24.7083 45.4447 25.5996 37.6834 25.4684 38.8258C25.3311 40.0283 24.3368 40.9366 23.1554 40.9366H7.83746C6.66012 40.9366 5.66582 40.0284 5.52855 38.8258C5.39738 37.6834 6.28863 45.4447 2.22949 10.0977H28.7675Z" fill="currentColor"/></svg>';

        variationList.each(function (i, e) {
            var value = $(this).val();
            var id = $(this).attr('id');
            var index = i + 1;
            var active = i === 0 ? ' active' : '';
            var itemTpl = `<div class="item size-${index}${active}" data-variation-id="${id}">${svg}<span class="option-item-title">${value}</span></div>`;
            tpl += itemTpl;
        });

        sizeOption.empty();
        sizeOption.append(tpl);

        var optionItem = $('.additional-options .size-option .item');
        optionItem.on('click', function () {
            optionItem.removeClass('active');
            $(this).addClass('active');
            var id = $(this).data('variation-id');

            $('#' + id).trigger('click');
        });

        var beverageTaberItem = $('.beverage-taber .info li');
        if (beverageTaberItem.length) {
            beverageTaberItem.on('click', function () {
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');

                var value = $(this).text();

                $('.variation-wrapper input[value="' + value + '"]').trigger(
                    'click'
                );
            });
        }

        var sugarOption = $('.sugar-option .item');
        if (sugarOption.length) {
            sugarOption.on('click', function () {
                var form = $('form.form');
                sugarOption.removeClass('active');
                $(this).addClass('active');
                var value = $(this).find('.option-item-title').text();

                var sugarInput = form.find('input[name="properties[Sugar]"]');
                if (sugarInput.length) {
                    sugarInput.val(value);
                } else {
                    var input =
                        '<input type="hidden" name="properties[Sugar]" value="' +
                        value +
                        '">';
                    form.append(input);
                }
            });
        }

        var teaspoonsOption = $('.teaspoons-option .item');
        if (teaspoonsOption.length) {
            teaspoonsOption.on('click', function () {
                var form = $('form.form');
                teaspoonsOption.removeClass('active');
                $(this).addClass('active');
                var value = $(this).text();

                var teaspoonInput = form.find(
                    'input[name="properties[Teaspoons]"]'
                );
                if (teaspoonInput.length) {
                    teaspoonInput.val(value);
                } else {
                    var input =
                        '<input type="hidden" name="properties[Teaspoons]" value="' +
                        value +
                        '">';
                    form.append(input);
                }
            });
        }

        var milkTypeItem = $('.milk-type-info li');
        if (milkTypeItem.length) {
            milkTypeItem.on('click', function () {
                $(this).parent().find('li').removeClass('active');
                $(this).addClass('active');

                var cartInput = $(this).parents('.info').find('.cart-input');
                var variantId = $(this).data('id');
                var variantTitle = $(this).data('title');
                cartInput.attr('data-variant-id', variantId);
                cartInput.attr('data-variant-title', variantTitle);
            });
        }

        /* Shots Quantity */
        var shotsQuantity = $('.shots-quantity');
        if (shotsQuantity.length) {
            shotsQuantity.each(function () {
                var quantityInput = $(this).find('.quantity-value');
                var maxValue = +quantityInput.attr('max');
                var shotTitle = quantityInput.attr('name');
                var shotId = quantityInput.data('id');
                var plus = $(this).find('.plus');
                var minus = $(this).find('.minus');
                plus.on('click', function () {
                    var quantityInput = $(this)
                        .parent()
                        .find('.quantity-value');
                    var currentQuantity = +quantityInput.val();
                    var newQuantity = currentQuantity + 1;
                    newQuantity =
                        newQuantity > maxValue ? maxValue : newQuantity;
                    quantityInput.val(newQuantity);
                });
                minus.on('click', function () {
                    var quantityInput = $(this)
                        .parent()
                        .find('.quantity-value');
                    var currentQuantity = +quantityInput.val();
                    var newQuantity = currentQuantity - 1;
                    newQuantity = newQuantity < 0 ? 0 : newQuantity;
                    quantityInput.val(newQuantity);
                });
            });
        }

        /* Get Paid Add-on to Cart */
        var addToCartForm = $('form.form');
        /*$(document).on('click', 'button[type="submit"]', function (e) {
            //e.preventDefault();
            const form = $(this).closest('form');

            form.append(
                '<input type="hidden" name="properties[Color]" value="Red">'
            );
            form.append(
                '<input type="hidden" name="properties[CustomID]" value="12345">'
            );
            console.log('add to cart');
        });*/
        if (addToCartForm.length) {
            $(this).on('click', 'button[type="submit"]', function (e) {
                e.preventDefault();
                var items = [];
                var form = $(this).closest('form');
                var formData = new FormData(form[0]);
                var mainVariantId = formData.get('id');
                var mainQty = parseInt(formData.get('quantity')) || 1;
                var mainProduct = {
                    id: mainVariantId,
                    quantity: mainQty,
                    properties: {},
                };

                var btn = $(this);
                var errorContainer = $('.product-form__error-message-wrapper');
                errorContainer.hide();
                btn.addClass('button--loading').attr('disabled', true);

                var sugarOption = $('.sugar-option .item.active');
                if (sugarOption.length) {
                    var title = sugarOption
                        .parents('.option-box')
                        .find('.option-title')
                        .text();
                    var value = sugarOption.find('.option-item-title').text();
                    mainProduct.properties[title] = value;
                }
                var teaspoonsOption = $('.teaspoons-option .item.active');
                if (teaspoonsOption.length) {
                    var title = teaspoonsOption
                        .parents('.option-box')
                        .find('.option-title')
                        .text();
                    var value = teaspoonsOption.text();
                    mainProduct.properties[title] = value;
                }

                var pickupOption = $('.pickup-option.active');
                if (pickupOption.length) {
                    var value = pickupOption.find('.free-price').text();
                    mainProduct.properties['Pickup'] = value;
                }

                $('.paid-add-on .cart-input').each(function () {
                    var addonId = parseInt($(this).data('variant-id'));
                    var qty = parseInt($(this).val());
                    var addonTitle = $(this).attr('name');
                    var addonVariantTitle = $(this).data('variant-title') || '';

                    if (!addonId || !qty || qty < 1) return;

                    items.push({
                        id: addonId,
                        quantity: qty,
                        properties: {
                            _addon_title: addonTitle,
                            _variant_title: addonVariantTitle,
                            _linked_to: mainVariantId,
                        },
                    });
                });

                if (items.length != 0) {
                    mainProduct.properties._has_paid_addon = true;
                }

                items.push(mainProduct);
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: JSON.stringify({ items }),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function (response) {
                        console.log('Cart updated:', response);
                        setTimeout(function () {
                            window.location.href = '/cart';
                        }, 500);
                    },
                    error: function (xhr) {
                        console.error('Error adding items:', xhr);

                        let message = 'An error occurred. Please try again.';

                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.description) {
                                message = response.description;
                            }
                        } catch (e) {
                            console.warn('Error parsing error response:', e);
                        }

                        if (errorContainer.length) {
                            errorContainer
                                .find('.product-form__error-message')
                                .text(message);
                            errorContainer.show();
                        } else {
                            alert(message);
                        }
                    },
                    complete: function () {
                        btn.removeClass('button--loading').attr(
                            'disabled',
                            false
                        );
                    },
                });
            });
        }
    }
    // ==== End Beverage Product ====

    // ==== Cart Remove Paid Addon Button ====
    var removePaidAddon = $('.remove-paid-addon-product');
    if (removePaidAddon.length) {
        $(this).on('click', '.remove-paid-addon-product', function () {
            const productId = $(this).data('id');
            const updates = {};
            const addons = $('[data-main-key="' + productId + '"');

            addons.each(function () {
                var key = $(this).data('addon-key');
                updates[key] = 0;
            });

            updates[productId] = 0;

            $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: { updates: updates },
                dataType: 'json',
                success: function (cart) {
                    console.log('Products removed');
                    location.reload();
                },
                error: function (error) {
                    console.error('Error while deleting:', error);
                },
            });

            return false;
        });
    }
    // ==== End Cart Remove Bundle Button ====

    // ==== Cart Remove Bundle Button ====
    var bundleRemoveButton = $('.bundle-remove-button');
    if (bundleRemoveButton.length) {
        $(this).on('click', '.bundle-remove-button', function () {
            const bundleId = $(this).data('remove-btn-id');

            fetch('/cart.js')
                .then((res) => res.json())
                .then((cart) => {
                    const updates = {};

                    cart.items.forEach((item) => {
                        if (
                            item.properties &&
                            item.properties._bundle_id === bundleId
                        ) {
                            updates[item.key] = 0;
                        } else {
                            updates[item.key] = item.quantity;
                        }
                    });

                    return fetch('/cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ updates }),
                    });
                })
                .then((res) => res.json())
                .then((cart) => {
                    location.reload();
                })
                .catch((err) => console.error('Error updating cart:', err));

            return false;
        });
    }
    // ==== End Cart Remove Bundle Button ====

    // ==== List Video Hover ====
    var listVideo = $('.links-block .item.has-video');
    if (listVideo.length) {
        listVideo
            .on('mouseenter', function () {
                var video = $(this).find('video')[0];
                video.play();
            })
            .on('mouseleave', function () {
                var video = $(this).find('video')[0];
                video.pause();
                video.currentTime = 0;
            });
    }
    // ==== End List Video Hover ====
    // ==== End Cart ====

    // ==== Animation ====
    AOS.init({
        duration: 1000,
        disable: 'phone',
    });
    // ==== End Animation ====


}